(() => {
  if (window.DonPerfumeContextualComplements) return;

  const getCartSectionIds = () => Array.from(document.querySelectorAll('cart-items-component'))
    .map((component) => component instanceof HTMLElement ? component.dataset.sectionId : '')
    .filter(Boolean);

  const addComplement = async (button) => {
    const variantId = button.dataset.variantId;
    if (!variantId || button.disabled) return;

    const card = button.closest('.es-context-card, [data-dpu-card]');
    const status = card?.querySelector('[data-es-complement-status]');
    const originalContent = button.innerHTML;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Añadiendo...';
    if (status) status.textContent = '';

    try {
      const sectionIds = getCartSectionIds();
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      if (sectionIds.length) formData.append('sections', sectionIds.join(','));

      const addResponse = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      });
      const addedItem = await addResponse.json();
      if (!addResponse.ok || addedItem.status) {
        throw new Error(addedItem.description || 'No se pudo añadir el producto.');
      }

      const root = window.Shopify?.routes?.root || '/';
      const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      const cart = await cartResponse.json();

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: button.dataset.sourceId || 'dp-contextual-complements',
          data: {
            source: 'dp-contextual-complements',
            itemCount: cart.item_count,
            variantId,
            sections: addedItem.sections || {}
          }
        }
      }));

      button.textContent = 'Añadido';
      if (status) status.textContent = 'Producto añadido al carrito.';

      if (button.dataset.openCart === 'true') {
        const drawer = document.querySelector('cart-drawer-component');
        if (drawer?.hasAttribute('auto-open') && typeof drawer.showDialog === 'function') {
          drawer.showDialog();
        }
      }

      window.setTimeout(() => {
        if (!button.isConnected) return;
        button.innerHTML = originalContent;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }, 1800);
    } catch (error) {
      button.textContent = 'Reintentar';
      if (status) status.textContent = error.message || 'No se pudo añadir. Prueba de nuevo.';
      window.setTimeout(() => {
        if (!button.isConnected) return;
        button.innerHTML = originalContent;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }, 2200);
    }
  };

  // Variante antes de añadir (Perfume Misterioso: femenino / masculino).
  document.addEventListener('click', (event) => {
    const pill = event.target.closest('[data-dpu-var]');
    if (!pill) return;
    const card = pill.closest('[data-dpu-card], .es-context-card');
    if (!card) return;
    card.querySelectorAll('[data-dpu-var]').forEach((o) => o.setAttribute('aria-pressed', o === pill ? 'true' : 'false'));
    const add = card.querySelector('[data-es-complement-add]');
    if (add) add.dataset.variantId = pill.dataset.dpuVar;
    const precio = card.querySelector('[data-dpu-precio]');
    if (precio && pill.dataset.dpuVarPrecio) precio.textContent = pill.dataset.dpuVarPrecio;
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-es-complement-add]');
    if (!button) return;
    event.preventDefault();
    addComplement(button);
  });

  window.DonPerfumeContextualComplements = { addComplement };
})();


/* ── Barra y flecha del carrusel de complementos ──────────────────
   El carrito se repinta al añadir o quitar, así que se vigila el
   documento y se monta cada vez que vuelve a aparecer la lista. */
(() => {
  const montar = (lista) => {
    if (!lista || lista.dataset.dpuNav) return;
    lista.dataset.dpuNav = '1';

    const nav = document.createElement('div');
    nav.className = 'dpu__nav';
    nav.innerHTML =
      '<span class="dpu__bar"><span></span></span>' +
      '<button type="button" class="dpu__next" aria-label="Ver más complementos">' +
      '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
      'stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>' +
      '</button>';
    lista.insertAdjacentElement('afterend', nav);

    const relleno = nav.querySelector('.dpu__bar > span');
    const flecha = nav.querySelector('.dpu__next');

    const pintar = () => {
      const recorrido = lista.scrollWidth - lista.clientWidth;
      if (recorrido < 8) { nav.hidden = true; return; }
      nav.hidden = false;
      const visible = lista.clientWidth / lista.scrollWidth;
      const avance = lista.scrollLeft / recorrido;
      relleno.style.width = (visible * 100) + '%';
      relleno.style.transform = 'translateX(' + (avance * (100 / visible - 100)) + '%)';
      flecha.disabled = avance > 0.98;
    };

    flecha.addEventListener('click', () => {
      lista.scrollBy({ left: lista.clientWidth * 0.9, behavior: 'smooth' });
    });
    lista.addEventListener('scroll', pintar, { passive: true });
    window.addEventListener('resize', pintar);
    pintar();
  };

  const revisar = () => document.querySelectorAll('.dpu__lista').forEach(montar);
  revisar();
  new MutationObserver(revisar).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('cart:update', () => setTimeout(revisar, 150));
})();